import React, { useState, useEffect } from "react";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';

export const CaseStudies = ({ settings }) => {
  const { 
    title, 
    description 
  } = settings.settings.section || {};
  
  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Add a small delay before showing the animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  // Extract awards from metaobjects
  const caseStudies = settings.settings.caseStudiesData || [];

  return (
    <section className="py-12">
   
      <div className="container mx-auto px-4">
        {(title || description) && (
          <div className="mb-12 text-center">
            {title && <h2 className="">{title}</h2>}
            {description && <Paragraph text={description} maxChars={5000} classes=""/>}
          </div>
        )}

        <div className={`grid ${isMobile ? "grid-cols-1 gap-6" : "grid-cols-3 gap-8"}`}>
          {caseStudies.map((study, index) => (
            <a href={`/pages/case-studies/${study.handle}`} className={'flex relative h-[456px]'}>
              <div className="w-full h-full overflow-hidden rounded-[4px] relative">
                {study.image &&
                  <img 
                    src={study.image} 
                    alt={study.title} 
                    className="w-full h-full object-cover pointer-events-none"
                  />
                }
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-50 pointer-events-none"></div>
                <div className="absolute inset-0 flex flex-col gap-y-2 z-[10] text-white pointer-events-none p-6">
                  <div className="flex flex-col mb-[32px] gap-y-[32px]">
                    {study.year && (
                      <span className="">{study.year}</span>
                    )}

                    <h3 className="h4">{study.title}</h3>
                  </div>

                  <div className={`flex flex-col justify-end items-end h-full`}>
                      {study.description && (
                          <Paragraph classes={`b_small_light`} text={study.description} maxChars={120}/>
                      )}
                      {study.category && (
                          <Paragraph text={study.category} maxChars={500} />
                      )}
                      {study.business_unit && (
                          <Paragraph text={study.business_unit} maxChars={120}/>
                      )}
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
